import { useState } from "react";
import { persons } from "@/mocks/gossip";

const catBadge: Record<string, string> = {
  明星: "text-[rgb(var(--brand))] bg-[rgb(var(--brand))]/10",
  网红: "text-[rgb(126,158,106)] bg-[rgb(126,158,106)]/10",
  主播: "text-[rgb(224,124,45)] bg-[rgb(224,124,45)]/10",
};

export default function PersonArchive() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="persons" className="w-full bg-[rgb(var(--paper-deep))]/60">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-6 flex flex-col justify-between gap-3 md:mb-8 md:flex-row md:items-end">
          <div>
            <div className="mb-2 flex items-center gap-2 text-[12px] font-semibold tracking-[0.25em] text-[rgb(var(--brand))]">
              <i className="ri-vip-crown-2-line h-4 w-4 flex items-center justify-center"></i>
              人物归类
            </div>
            <h2 className="font-display text-[24px] font-black leading-tight md:text-[30px]">
              翻车档案，按人一瓜到底
            </h2>
            <p className="mt-1 text-[13px] text-[rgb(var(--ink-soft))]">
              同一位公众人物的黑料、黑历史与翻车现场归到一页，事件时间与后续一目了然
            </p>
          </div>
          <a
            href="#gallery"
            className="flex shrink-0 items-center gap-1 whitespace-nowrap text-[13px] font-medium text-[rgb(var(--brand))] transition-colors hover:text-[rgb(var(--brand-deep))]"
          >
            全部人物档案
            <i className="ri-arrow-right-line h-4 w-4 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {persons.map((p) => {
            const isOpen = openId === p.id;
            return (
              <article
                key={p.id}
                className={`flex flex-col rounded-lg border bg-white transition-colors ${
                  isOpen
                    ? "border-[rgb(var(--brand))]/40"
                    : "border-[rgb(var(--ink))]/10 hover:border-[rgb(var(--ink))]/25"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? null : p.id)}
                  className="flex flex-1 flex-col p-4 text-left"
                >
                  <div className="flex items-center gap-3">
                    <span
                      className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-md font-display text-[20px] font-black text-[rgb(var(--paper))] ${
                        p.id === 1 ? "bg-[rgb(var(--brand))]" : "bg-[rgb(var(--ink))]"
                      }`}
                    >
                      {p.glyph}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-2">
                        <h3 className="font-display text-[17px] font-black">{p.name}</h3>
                        <span
                          className={`whitespace-nowrap rounded-full px-2 py-0.5 text-[10px] font-semibold ${catBadge[p.category]}`}
                        >
                          {p.category}
                        </span>
                      </div>
                      <p className="mt-0.5 truncate text-[12px] text-[rgb(var(--ink-soft))]">
                        {p.tone}
                      </p>
                    </div>
                  </div>

                  <p className="mt-3 line-clamp-2 text-[13px] leading-relaxed text-[rgb(var(--ink))]/80">
                    {p.tagline}
                  </p>

                  <div
                    className={`grid grid-rows-[0fr] transition-all duration-300 ${
                      isOpen ? "grid-rows-[1fr] pt-3" : ""
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="rounded-md bg-[rgb(var(--paper))] px-3 py-2.5 text-[12px] leading-relaxed text-[rgb(var(--ink-soft))]">
                        <span className="font-semibold text-[rgb(var(--brand))]">速览 · </span>
                        {p.peek}
                      </p>
                    </div>
                  </div>

                  <div className="mt-auto flex items-center justify-between pt-3 text-[11px] text-[rgb(var(--ink-soft))]">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line h-3.5 w-3.5 flex items-center justify-center"></i>
                      始于 {p.since}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-inbox-archive-line h-3.5 w-3.5 flex items-center justify-center"></i>
                      收录 {p.entries} 条
                    </span>
                  </div>
                </button>
                <div className="mx-4 mb-3 mt-1 flex items-center justify-center rounded-md bg-[rgb(var(--ink))] py-2 text-[12px] font-medium text-[rgb(var(--paper))] transition-colors hover:bg-[rgb(var(--brand))]">
                  围观 {p.name} 的完整档案
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}